import { usePegComponent } from '@/composables/usePegComponent';

export default {
  name: "PegComponent",
  
  props: {
    id: { type: [String, Number], required: true },
    layer: { type: [String, Number], required: true },
    portfolio: { type: [String, Number], required: true },
    drivers: { type: Array, default: () => [] },
    x: { type: Number, required: true },
    y: { type: Number, required: true },
    show: { type: Boolean, default: true },
    slug: { type: String, required: true },
    title: { type: String, required: true },
    orderindex: { type: Number, default: 0 },
    viewport_width: { type: Number, required: true },
    viewport_height: { type: Number, required: true },
    thumbnail: { type: String, default: '' },
    percentage: { type: Number, default: 0 },
    zoom: { type: Number, default: 1 },
  },

  setup(props) {
    return usePegComponent(props);
  },
};